import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ExternalRequestsService {

  // cronRecoveries: Ruta del cron de recuperaciones
  cronRecoveries = "https://www.burodeconexiones.com/gc_balanced/cron/contact_center_informe_recuperaciones.php";
  // cronIRL: Ruta del cron de IRL
  // cronIRL = "http://192.168.2.120/cron/IRL/SaveHistoricalController.php?cron=0";
  cronIRL = "https://www.burodeconexiones.com/gc_balanced/cron/IRL/SaveHistoricalController.php?cron=0";
  // risk: Ruta del API de GC Risk
  // risk = "https://www.gcrisk.co/perdidaEsperada/colombia/operativo/controlador.php";
  // gcm: Ruta del API de GCM
  gcm = "https://www.gcm.garantiascomunitarias.com/api/v2/indicadores-redes-medios";
  // bdr: Ruta del API de Banca de riesgo
  bdr = "https://www.bancaderiesgo.com/proyectos_admon/indicadores/controller.php";
  // rep: Ruta del API de Servicios Repotencia
  rep = "https://www.repotencia.com/gcrepotencia/services/";
  // brk: Ruta del API de Servicios Bloomrisk
  brk = "https://www.gcbloomrisk.com/back/api";
  // brk = "http://192.168.2.120:8800/api";

  constructor(private http: HttpClient) { }

  // getInformationFromRisk(data) {
  //   return this.http.post(this.risk, data, HEADERS);
  // }
  // getInformationFromRisk() Obtiene información de los servicios de gc risk.
  getInformationFromRisk = (data: FormData): Observable<any> => this.http.post(environment.apiPath + "ApiNetworkIndicators/" + "getIndicatorsFromRiskService", data, HEADERS);

  // updateRecoveriesLastMonth() Ejecuta el cron que actualiza las recuperaciones en informes hasta pasados 10 días del mes
  updateRecoveriesLastMonth = (): Observable<any> => this.http.get(this.cronRecoveries + "?moment=" + new Date().getDate(), HEADERS);

  // updateIRL() Ejecuta el cron que actualiza los resultados del IRL del día actual
  updateIRL = (): Observable<any> => this.http.get(this.cronIRL, HEADERS);

  // getInformationFromBdr() Obtiene información de los servicios de banca de riesgos.
  getInformationFromBdr = (data: FormData): Observable<any> => this.http.post(this.bdr, data, HEADERS);

  // getInformationFromGCM() Obtiene información de los servicios de GCM para medios y marketing.
  getInformationFromGCM = (data: FormData): Observable<any> => this.http.post(this.gcm, data, HEADERS);

  // getInformationFromGCM() Obtiene información de los servicios de GCM para medios y marketing.
  getInformationFromRepotencia = (path: string, data: FormData): Observable<any> => this.http.post(`${this.rep}${path}`, data, HEADERS);

  // getInformationFromBloomrisk() Obtiene información de los servicios de Bloomrisk.
  getInformationFromBloomrisk = (path: string, data: FormData): Observable<any> => this.http.post(`${this.brk}${path}`, data, HEADERS);

}
